import React, { useMemo } from 'react';
import { FormContext } from './FormContext';
import { FormContextType } from './types';

interface Props extends FormContextType {
  children?: React.ReactNode;
}

/**
 * A component that can be used to provide form information to other components in the
 * component tree.
 */
export const FormProvider = ({ prefix, errors, value, children }: Props) => {
  const contextValue = useMemo(() => ({ prefix, errors, value }), [prefix, errors, value]);
  return <FormContext.Provider value={contextValue}>{children}</FormContext.Provider>;
};
